// extracted by mini-css-extract-plugin
export default {"btnHome":"btnHome_btnHome__jbncu"};